module.exports = __webpack_public_path__ + "img/target_pin_green.d9dd0ebc.svg";